import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ItemsList, MenuModalStyle, MenuMouseArea, ModalHeader, } from "../styles";
import { MenuSubitem } from "../MenuSubitem";
import { createPortal } from "react-dom";
export var MenuModal = function (_a) {
    var _b, _c;
    var item = _a.item, props = __rest(_a, ["item"]);
    var elementById = (_b = document
        .getElementById("menu-item".concat(item.path))) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    var elementTop = (elementById === null || elementById === void 0 ? void 0 : elementById.top) || 0;
    var windowHeight = window.innerHeight;
    var maxHeight = windowHeight - elementTop - 16;
    var modalTop = Math.max(elementTop - 21, 8);
    var modalLeft = (elementById === null || elementById === void 0 ? void 0 : elementById.right) || 0;
    var arrowTop = elementById
        ? elementById.height / 2 - 8 + (elementTop - modalTop)
        : 0;
    return createPortal(_jsx(MenuMouseArea, { "$top": modalTop, "$left": modalLeft, "$maxHeight": maxHeight, "$arrowTop": arrowTop, children: _jsxs(MenuModalStyle, __assign({ onClick: function (e) { return e.stopPropagation(); } }, props, { children: [_jsx(ModalHeader, { children: item.text }), _jsx(ItemsList, { children: (_c = item.subitems) === null || _c === void 0 ? void 0 : _c.map(function (subitem) {
                        return (_jsx(MenuSubitem, { subitem: subitem, parentPath: item.path }, "menu-subitem".concat(item.path).concat(subitem.path)));
                    }) })] })) }), document.body);
};
//# sourceMappingURL=index.js.map